import Form from "./Form";
import FormStickyHeader from "../../components/FormStickyHeader";

type Props = {
  suppliers: Supplier[];
  projectManagers: { id: string; first_name: string; last_name: string }[];
};

const SupplierEdit: React.FC<Props> = ({ suppliers, projectManagers }) => {
  return (
    <div>
      <FormStickyHeader>Edit Project</FormStickyHeader>
      <Form suppliers={suppliers} projectManagers={projectManagers} />
    </div>
  );
};

export default SupplierEdit;
